import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import { NavLoader } from "ui/loader";
import { Notification } from "ui/notification";
import { ConnectedWsDeviceStatusConnStatus } from "ui/ws-ds-conn-status/connected-ws-ds-conn-status";
import { getErrorMessage } from "util/response";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

import { DeviceSelector } from "./device-selector";

class DeviceSelectList extends React.PureComponent {
  static get propTypes() {
    return {
      deviceFilter: PropTypes.func,
      devices: PropTypes.object.isRequired,
      deviceStatusOnline: PropTypes.bool,
      onSubmit: PropTypes.func.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      updatable_versions: PropTypes.func,
      successMessage: PropTypes.string,
      title: PropTypes.string.isRequired,
    };
  }

  static get defaultProps() {
    return {
      deviceFilter: () => true,
      successMessage: "Success!",
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      resetForm: false,
      submitted: false,
      successMessage: "",
      loading: true,
      updatable_player_versions: {},
    };

    this.submit = this._submit.bind(this);
  }

  _submit(selected) {
    if (!selected || selected.length === 0) {
      this.setState({ errorMessage: "Please select at least one device." });

      return;
    }

    const ids = selected.map((s) => s.id);

    this.setState(
      {
        errorMessage: "",
        submitted: true,
        successMessage: "",
      },
      this._postSubmit.bind(this, ids),
    );
  }

  componentDidMount() {
    if (this.props.updatable_versions) {
      this.props
        .updatable_versions()
        .then((versions) => {
          this.setState({
            loading: false,
            updatable_player_versions: versions["data"],
          });
        })
        .catch((error) => {
          this.setState({
            errorMessage: getErrorMessage(error),
            loading: false,
          });
        });
    } else {
      this.setState({ loading: false });
    }
  }

  _postSubmit(ids) {
    const { onSubmit, successMessage } = this.props;

    return onSubmit(ids)
      .then(() => {
        this.setState({
          successMessage,
          errorMessage: "",
          resetForm: true,
          submitted: false,
        });
      })
      .catch((e) => {
        this.setState({
          errorMessage: getErrorMessage(e),
          submitted: false,
          successMessage: "",
        });
      });
  }

  renderLoaderOrView() {
    const { storesLoaded } = this.props;
    const { loading } = this.state;

    if (!storesLoaded || loading) {
      return <NavLoader.Proxy />;
    }

    return (
      <Box title="" noHeader={true}>
        {this.renderView()}
      </Box>
    );
  }

  renderView() {
    const { deviceFilter, devices, deviceStatusOnline, title } = this.props;
    const { errorMessage, resetForm, submitted, successMessage } = this.state;

    const filteredDevices = Object.values(devices)
      .filter(deviceFilter)
      .reduce((acc, device) => {
        acc[device.id] = device;

        return acc;
      }, {});

    if (
      this.state.updatable_player_versions &&
      this.state.updatable_player_versions.data
    ) {
      const version = this.state.updatable_player_versions.data;
      Object.keys(filteredDevices).forEach((deviceId) => {
        filteredDevices[deviceId].downgrade_version = version;
      });
    }

    if (isEqual(filteredDevices, {})) {
      return "No devices available for action.";
    }

    const modalTitle = (
      <div>
        <strong>{title}, are you sure?</strong>
        <br />
        You will <em>not</em> be able to revert this change. Please double check
        the device list before you proceed.
      </div>
    );

    return (
      <div>
        <Row>
          <Col xs={12}>
            <ConnectedWsDeviceStatusConnStatus />
          </Col>
        </Row>
        <Notification
          error={errorMessage}
          success={successMessage}
          successChildren={<Link to="/devices">Device List</Link>}
        />
        <DeviceSelector
          action={title}
          devices={filteredDevices}
          deviceStatusOnline={deviceStatusOnline}
          modalTitle={modalTitle}
          resetForm={resetForm}
          submit={this.submit}
          submitted={submitted}
        />
      </div>
    );
  }

  render() {
    const { title } = this.props;

    return <Page title={title}>{this.renderLoaderOrView()}</Page>;
  }
}

export { DeviceSelectList };
